import { Button, List, Typography } from 'antd';
import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { useGetByIdPageNodeQuery } from '@/modules/Pages';

interface Props {
  siteId: string;
  loading: boolean;
  disableControlButtons: boolean;
  pageNodeChildren: BaseQueryParams<typeof useGetByIdPageNodeQuery>['data']['children'];
}

export const CollapseNodesList: FC<Props> = ({
  siteId,
  loading,
  disableControlButtons,
  pageNodeChildren
}) => {
  return (
    <List
      dataSource={ pageNodeChildren }
      loading={ loading }
      renderItem={ (node): ReactNode => (
        <List.Item
          key={ node.id }
          actions={ [
            <Link
              key="goToChildNode"
              to={ AppRoutes.PageNodesById.replace(':siteId', siteId).replace(':nodeId', node.id) }
            >
              <Button disabled={ disableControlButtons } type="default" size="small">
                перейти
              </Button>
            </Link>
          ] }
        >
          <Typography.Title level={ 5 } style={{ margin: 0 }}>
            { node.slug }
          </Typography.Title>
        </List.Item>
      ) }
    />
  );
};
